import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useMemo } from 'react';
import { CashLot, CashLotItem } from '../api/cash-lot';
import { getAggregatedCashLotItems } from './shared';

interface DaysCollectionProps {
  cashLot: CashLot;
  frequency: string;
}

interface DaysCollectionItem {
  value: number;
  trend: number;
  dateUnit: string;
}

const getDaysCollectionItems = (cashLotItems: CashLotItem[], frequency: string): DaysCollectionItem[] => {
  const aggregatedItems = getAggregatedCashLotItems(cashLotItems, frequency);
  const daysCollectionItems: DaysCollectionItem[] = [];

  for (let aggregatedItem of aggregatedItems) {
    let value = 0;

    for (let item of aggregatedItem.items) {
      value += item.variance * item.count;
    }

    value = value / aggregatedItem.items.reduce((acc, curr) => acc + curr.count , 0);

    daysCollectionItems.push({
      value,
      trend: value,
      dateUnit: aggregatedItem.dateUnit
    })
  }

  return daysCollectionItems;
};

const getDaysCollectionHighchartOptions = (items: DaysCollectionItem[]): Highcharts.Options => {
  return {
    chart: {
      width: 290,
      height: 150
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: items.map(x => x.dateUnit)
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
            enabled: false
        }
      }
    },
    colors: ['#052C4C', '#3FB1E3', '#2e6586'],
    series: [
      {
          type: 'column',
          name: 'Variance',
          data: items.map(x => x.value)
      },
      {
          type: 'spline',
          name: 'Trend',
          data: items.map(x => x.trend),
          color: Highcharts.getOptions().colors[3],
          marker: {
              lineWidth: 2,
              lineColor: Highcharts.getOptions().colors[3],
              fillColor: 'white'
          }
      }
    ],
    credits:{
      enabled: false
    }
  };
};

export const DSO = ({ cashLot, frequency }: DaysCollectionProps) => {
  const items = useMemo(() => getDaysCollectionItems(cashLot.items.filter(x => x.type === 'Invoice' && (x.state === 'Reconciled' || x.state === 'Booked')), frequency), [cashLot.items['_changeToken'], frequency]);

  const options = getDaysCollectionHighchartOptions(items);

  return (<HighchartsReact highcharts={Highcharts} options={options} />);
};

export const DaysDeliquent = ({ cashLot, frequency } : DaysCollectionProps) => {
  const items = useMemo(() => getDaysCollectionItems(cashLot.items.filter(x => x.type === 'Invoice' && x.variance > 0 && (x.state === 'Reconciled' || x.state === 'Booked')), frequency), [cashLot.items['_changeToken'], frequency]);

  const options = getDaysCollectionHighchartOptions(items);

  return (<HighchartsReact highcharts={Highcharts} options={options} />);
};
